import { render, staticRenderFns } from "./shop-create-location-modal.vue?vue&type=template&id=367f0784&scoped=true&"
import script from "./shop-create-location-modal.vue?vue&type=script&lang=js&"
export * from "./shop-create-location-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367f0784",
  null
  
)

export default component.exports